import { useContext, useMemo, useState } from "react";
import { Flex, Typography, Avatar } from "antd";

import CalendarWidget from "@/components/Widgets/CalendarWidget";
import NoticesWidget from "@/components/Widgets/NoticesWidget";
import ContactsWidget from "@/components/Widgets/ContactsWidget";
import AllStatisticsWidget from "@/components/Widgets/AllStatisticsWidget";
import DeadlineWidget from "@/components/Widgets/DeadlineWidget";
import OverdueWidget from "@/components/Widgets/OverdueWidget";

import CustomSelect from "@/components/inputs/CustomSelect";

import { UserContext } from "@/context/UserContext";

const { Title } = Typography;

const TASK_OPTIONS = [
  { label: "Все доступные задачи", value: "" },
  { label: "Я исполнитель", value: "executor" },
];

const Dashboards = () => {
  const { user } = useContext(UserContext);

  const initials = useMemo(() => {
    return `${user.lastname?.[0] ?? ""}${user.firstname?.[0] ?? ""}`;
  }, [user]);

  const [tasksFilter, setTasksFilter] = useState("");

  return (
    <>
      <div
        style={{
          padding: "10px 0 17px",
          borderBottom: "1px solid #E9E9E9",
          marginBottom: 17,
        }}
      >
        <Flex justify="space-between">
          <Flex align="center" gap={8}>
            <Avatar
              size={32}
              src={user.avatar}
              style={{
                color: "#f56a00",
                backgroundColor: "#fde3cf",
                border: "none",
                textTransform: "uppercase",
              }}
            >
              {initials}
            </Avatar>
            <Title level={2} className="no-margin">
              Моя страница
            </Title>
          </Flex>
        </Flex>
      </div>
      <Flex vertical gap={25}>
        <Flex gap={20} wrap>
          <div style={{ flex: 1, minWidth: 300 }}>
            <CalendarWidget />
          </div>
          <div style={{ flex: 1, minWidth: 300 }}>
            <NoticesWidget />
          </div>
          <div style={{ flex: 1, minWidth: 300 }}>
            <ContactsWidget />
          </div>
        </Flex>
        <div style={{ borderBottom: "1px solid #E9E9E9" }} />
        <Flex vertical gap={15}>
          <div>
            <CustomSelect
              options={TASK_OPTIONS}
              style={{
                width: 200,
              }}
              allowClear={false}
              popupMatchSelectWidth={false}
              value={tasksFilter}
              onChange={setTasksFilter}
            />
          </div>
          <Flex gap={20} wrap>
            <div style={{ flex: 1, minWidth: 300 }}>
              <AllStatisticsWidget type_filter={tasksFilter} />
            </div>
            <div style={{ flex: 1, minWidth: 300 }}>
              <DeadlineWidget type_filter={tasksFilter} />
            </div>
            <div style={{ flex: 1, minWidth: 300 }}>
              <OverdueWidget type_filter={tasksFilter} />
            </div>
          </Flex>
        </Flex>
      </Flex>
    </>
  );
};

export default Dashboards;
